export const isVideoElementReady = (video) =>
	Boolean(
		video && video.readyState >= HTMLMediaElement.HAVE_METADATA,
	);

export const bindVideoReadyListeners = (video, onReady, onError) => {
	if (!video) {
		return () => {};
	}

	const markReady = () => {
		if (isVideoElementReady(video)) {
			onReady();
		}
	};

	const markError = () => {
		onError?.();
	};

	if (isVideoElementReady(video)) {
		onReady();
		return () => {};
	}

	const events = ['loadedmetadata', 'loadeddata', 'canplay'];

	events.forEach((eventName) => {
		video.addEventListener(eventName, markReady);
	});
	video.addEventListener('error', markError);

	return () => {
		events.forEach((eventName) => {
			video.removeEventListener(eventName, markReady);
		});
		video.removeEventListener('error', markError);
	};
};

export const playVideoSafely = (video) => {
	if (!video) {
		return;
	}

	video.play().catch(() => {});
};
